<template>
  <page>
    <!-- <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-printer</v-icon>
        <v-toolbar-title>Reprint Policy Documentation</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text> -->
    <form>
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <message :messages="messages"></message>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        ref="polNo"
                        v-model="form.polNo"
                        :label="labels.polNo"
                        :error-messages="errors.collect('polNo')"
                        data-vv-name="polNo"
                        :data-vv-as="labels.polNo"
                        v-validate="'required'"
                        @change="getPolicy"
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="showPolicyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.renCnt"
                        :label="labels.renCnt"
                        :error-messages="errors.collect('renCnt')"
                        data-vv-name="renCnt"
                        :data-vv-as="labels.renCnt"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                        @change="getPolicy"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.endtCnt"
                        :label="labels.endtCnt"
                        :error-messages="errors.collect('endtCnt')"
                        data-vv-name="endtCnt"
                        :data-vv-as="labels.endtCnt"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                        @change="getPolicy"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Sub-Filters</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                        v-model="form.prtSched"
                        :label="labels.prtSched"
                        :error-messages="errors.collect('prtSched')"
                        data-vv-name="prtSched"
                        :data-vv-as="labels.prtSched"
                        v-validate="'required'"
                        @change="defaultNoCopies($event, 'prtSched')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.noPrtSched"
                        :label="labels.noPrtSched"
                        :error-messages="errors.collect('noPrtSched')"
                        data-vv-name="noPrtSched"
                        :data-vv-as="labels.noPrtSched"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                        v-model="form.prtDrCr"
                        :label="labels.prtDrCr"
                        :error-messages="errors.collect('prtDrCr')"
                        data-vv-name="prtDrCr"
                        :data-vv-as="labels.prtDrCr"
                        v-validate="'required'"
                        @change="defaultNoCopies($event, 'prtDrCr')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.noPrtDrCr"
                        :label="labels.noPrtDrCr"
                        :error-messages="errors.collect('noPrtDrCr')"
                        data-vv-name="noPrtDrCr"
                        :data-vv-as="labels.noPrtDrCr"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <!-- <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                        v-model="form.prtDrCrAdv"
                        :label="labels.prtDrCrAdv"
                        :error-messages="errors.collect('prtDrCrAdv')"
                        data-vv-name="prtDrCrAdv"
                        :data-vv-as="labels.prtDrCrAdv"
                        v-validate="'required'"
                        @change="defaultNoCopies($event, 'prtDrCrAdv')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.noPrtDrCrAdv"
                        :label="labels.noPrtDrCrAdv"
                        :error-messages="errors.collect('noPrtDrCrAdv')"
                        data-vv-name="noPrtDrCrAdv"
                        :data-vv-as="labels.noPrtDrCrAdv"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout> -->
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                        v-model="form.prtTaxInv"
                        :label="labels.prtTaxInv"
                        :error-messages="errors.collect('prtTaxInv')"
                        data-vv-name="prtTaxInv"
                        :data-vv-as="labels.prtTaxInv"
                        v-validate="'required'"
                        @change="defaultNoCopies($event, 'prtTaxInv')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.noPrtTaxInv"
                        :label="labels.noPrtTaxInv"
                        :error-messages="errors.collect('noPrtTaxInv')"
                        data-vv-name="noPrtTaxInv"
                        :data-vv-as="labels.noPrtTaxInv"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                        v-model="form.prtRiApp"
                        :label="labels.prtRiApp"
                        :error-messages="errors.collect('prtRiApp')"
                        data-vv-name="prtRiApp"
                        :data-vv-as="labels.prtRiApp"
                        v-validate="'required'"
                        @change="defaultNoCopies($event, 'prtRiApp')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.noPrtRiApp"
                        :label="labels.noPrtRiApp"
                        :error-messages="errors.collect('noPrtRiApp')"
                        data-vv-name="noPrtRiApp"
                        :data-vv-as="labels.noPrtRiApp"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        v-model="form.riCo"
                        :label="labels.riCo"
                        :error-messages="errors.collect('riCo')"
                        data-vv-name="riCo"
                        :data-vv-as="labels.riCo"
                        :disabled="disabledRiCo"
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="doRiCoHelpList" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                        v-model="form.prtCi"
                        :label="labels.prtCi"
                        :error-messages="errors.collect('prtCi')"
                        data-vv-name="prtCi"
                        :data-vv-as="labels.prtCi"
                        v-validate="'required'"
                        @change="defaultNoCopies($event, 'prtCi')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.noPrtCi"
                        :label="labels.noPrtCi"
                        :error-messages="errors.collect('noPrtCi')"
                        data-vv-name="noPrtCi"
                        :data-vv-as="labels.noPrtCi"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-autocomplete
                        :items="vehRegNoList"
                        v-model="form.vehRegNo"
                        :label="labels.vehRegNo"
                        item-text="label"
                        item-value="value"
                        data-vv-name="vehRegNo"
                        :data-vv-as="labels.vehRegNo"
                        :error-messages="errors.collect('vehRegNo')"
                        :disabled="disableVehRegNo"
                        :loading="loading"
                        clearable
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4>
                      <v-checkbox
                        v-model="form.prtCoinsSvcFee"
                        :label="labels.prtCoinsSvcFee"
                        :error-messages="errors.collect('prtCoinsSvcFee')"
                        data-vv-name="prtCoinsSvcFee"
                        :data-vv-as="labels.prtCoinsSvcFee"
                        v-validate="'required'"
                        @change="defaultNoCopies($event, 'prtCoinsSvcFee')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.noPrtCoinsSvcFee"
                        :label="labels.noPrtCoinsSvcFee"
                        :error-messages="errors.collect('noPrtCoinsSvcFee')"
                        data-vv-name="noPrtCoinsSvcFee"
                        :data-vv-as="labels.noPrtCoinsSvcFee"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 lg4></v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              {{ labels.export }}
              <v-icon right dark>mdi-file-export</v-icon>
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
    <warning v-model="showWarningMsg" @ok="doAccept">{{ noCopyWarningMsg }}</warning>
    <!-- Policy HelpList -->
    <v-dialog v-model="showPolicyHelpList" width="1280px">
      <policy-help-list :apiURI="apiURI" @close="showPolicyHelpList = false" @assign-policy="assignPolicy($event)"></policy-help-list>
    </v-dialog>
    <!-- RI Company HelpList -->
    <v-dialog v-model="showRiCoHelpList" width="1280px">
      <ri-co-help-list
        v-if="showRiCoHelpList"
        :objData="riCoHelpListParam"
        @close="showRiCoHelpList = false"
        @assign-riCo="assignRiCo($event)"
      ></ri-co-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import PolicyHelpList from './helplist/PolicyHelpList'
import { expandURI } from '@/utils/ajax'
import RiCoHelpList from './helplist/RiCoHelpList'

export default {
  data() {
    return {
      labels: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        endtCnt: 'Endt Count',
        prtSched: 'Print Policy Schedule',
        noPrtSched: 'No. Print Policy Schedule',
        prtDrCr: 'Print Debit/Credit Note',
        noPrtDrCr: 'No. Print Debit/Credit Note',
        prtDrCrAdv: 'Print Debit/Credit Note (Advice)',
        noPrtDrCrAdv: 'No. Print Debit/Credit Note (Advice)',
        // prtTaxInv: 'Print Tax Invoice',
        // noPrtTaxInv: 'No. Print Tax Invoice',
        prtTaxInv: 'Print Debit/Credit Note (Advice)',
        noPrtTaxInv: 'No. Print Debit/Credit Note (Advice)',
        prtRiApp: 'Print RI Application',
        noPrtRiApp: 'No. Print RI Application',
        prtCi: 'Print CI',
        noPrtCi: 'No. Print CI',
        callingProg: 'Calling Program',
        export: 'Export to',
        vehRegNo: 'Specific Vehicle No. to Print',
        riCo: 'RI Company / RI Type',
        prtCoinsSvcFee: 'Print Coinsurance Service Fee Debit / Credit Note',
        noPrtCoinsSvcFee: 'No. Print Coinsurance Service Fee Debit / Credit Note'
      },
      form: {
        polNo: '',
        renCnt: '',
        endtCnt: '',
        prtSched: false,
        noPrtSched: 0,
        prtDrCr: false,
        noPrtDrCr: 0,
        prtDrCrAdv: false,
        noPrtDrCrAdv: 0,
        prtTaxInv: false,
        noPrtTaxInv: 0,
        prtRiApp: false,
        noPrtRiApp: 0,
        prtCi: false,
        selectedDoc: '',
        noPrtCi: 0,
        callingProg: 'Reprint',
        format: 'PDF',
        sendEmail: false,
        vehRegNo: undefined,
        riCo: undefined,
        prtCoinsSvcFee: false,
        noPrtCoinsSvcFee: 0,
        isMtrCI: true
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      showWarningMsg: false,
      noCopyWarningMsg: 'Number of copy exceed 10, would you like to proceed?',
      showPolicyHelpList: false,
      vehRegNoList: [],
      panel1: [0],
      panel2: [],
      apiURI: undefined,
      showRiCoHelpList: false,
      riCoHelpListParam: {
        polNo: '',
        renCnt: 0,
        endtCnt: 0
      },
      disabledRiCo: true,
      disableVehRegNo: false,
      loading: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function(value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initUwdrcr
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
            this.apiURI = this.menu.getPolicyHelpList
          }
        }
      } catch (err) {}
    },
    doAccept() {
      this.processExport()
      this.showWarningMsg = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (
            !(
              this.form.prtSched ||
              this.form.prtDrCr ||
              this.form.prtDrCrAdv ||
              this.form.prtTaxInv ||
              this.form.prtRiApp ||
              this.form.prtCi ||
              this.form.prtCoinsSvcFee
            )
          ) {
            this.errorMessage('Select at least one Policy Document to print.')
          } else if (
            this.form.noPrtSched > 10 ||
            this.form.noPrtDrCr > 10 ||
            this.form.noPrtDrCrAdv > 10 ||
            this.form.noPrtTaxInv > 10 ||
            this.form.noPrtRiApp > 10 ||
            this.form.noPrtCoinsSvcFee > 10
          ) {
            this.showWarningMsg = true
          } else {
            this.processExport()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        this.submitting = true
        try {
          var sendForm = clone(this.form)
          sendForm.prtSched = sendForm.prtSched === true ? 1 : 0
          sendForm.prtDrCr = sendForm.prtDrCr === true ? 1 : 0
          sendForm.prtDrCrAdv = sendForm.prtDrCrAdv === true ? 1 : 0
          sendForm.prtTaxInv = sendForm.prtTaxInv === true ? 1 : 0
          sendForm.prtRiApp = sendForm.prtRiApp === true ? 1 : 0
          sendForm.prtCi = sendForm.prtCi === true ? 1 : 0
          sendForm.prtCoinsSvcFee = sendForm.prtCoinsSvcFee === true ? 1 : 0
          sendForm.isMtrCI = sendForm.isMtrCI === true ? 1 : 0
          await this.$http.post(apiURI, sendForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            let exist = false
            if (data.fieldMessages) {
              for (var i = 0; i < data.fieldMessages.length; i++) {
                let compare = data.fieldMessages[i].field === 'polNo'
                if (compare) {
                  exist = true
                  break
                }
              }
            }

            if (exist) {
              this.fieldMessage(data)
            }
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    defaultNoCopies(vCheck, pId) {
      if (pId === 'prtSched') {
        this.form.noPrtSched = vCheck === true ? 1 : 0
      } else if (pId === 'prtDrCr') {
        this.form.noPrtDrCr = vCheck === true ? 1 : 0
      } else if (pId === 'prtDrCrAdv') {
        this.form.noPrtDrCrAdv = vCheck === true ? 1 : 0
      } else if (pId === 'prtTaxInv') {
        this.form.noPrtTaxInv = vCheck === true ? 1 : 0
      } else if (pId === 'prtRiApp') {
        this.form.noPrtRiApp = vCheck === true ? 1 : 0
        if (this.form.noPrtRiApp === 0 && this.form.prtRiApp === false) {
          this.form.riCo = undefined
          this.disabledRiCo = true
        } else {
          this.disabledRiCo = false
        }
      } else if (pId === 'prtCi') {
        this.form.noPrtCi = vCheck === true ? 1 : 0
        if (this.form.prtCi) {
          this.valCIType()
        }
      } else if (pId === 'prtCoinsSvcFee') {
        this.form.noPrtCoinsSvcFee = vCheck === true ? 1 : 0
      }
    },
    async valCIType() {
      this.loading = true
      const apiURI = this.menu.valCIType
      if (apiURI) {
        try {
          const expand = {
            polNo: this.form.polNo,
            renCnt: this.form.renCnt,
            endtCnt: this.form.endtCnt
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.form.isMtrCI = result.data.data.isMtrCI
            if (this.form.isMtrCI === true) {
              this.disableVehRegNo = false
            } else {
              this.disableVehRegNo = true
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignPolicy(data) {
      this.form.polNo = data.polNo
      this.form.renCnt = data.renCnt
      this.form.endtCnt = data.endtCnt
      this.showPolicyHelpList = false
      this.$refs.polNo.focus()
      this.getPolicy()
    },
    assignRiCo(data) {
      this.form.riCo = data.riCo + ' / ' + data.riType
    },
    async getPolicy() {
      if (this.form.polNo !== '' && this.form.renCnt !== '' && this.form.endtCnt !== '') {
        this.resetMessages()
        this.vehRegNoList = []
        this.form.prtCi = false
        this.form.noPrtCi = 0
        this.form.vehRegNo = undefined
        const apiUrl = this.menu.getPolicy
        if (apiUrl) {
          try {
            const expand = {
              polNo: this.form.polNo,
              renCnt: this.form.renCnt,
              endtCnt: this.form.endtCnt
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result) {
              this.form.prtCi = result.data.ciPrt
              this.form.noPrtCi = result.data.noCiprt
              this.$set(this, 'vehRegNoList', result.data.vehRegNoList)
            }
          } catch (err) {
            this.vehRegNoList = []
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    doRiCoHelpList() {
      this.riCoHelpListParam.polNo = this.form.polNo
      this.riCoHelpListParam.renCnt = this.form.renCnt === '' ? 0 : this.form.renCnt
      this.riCoHelpListParam.endtCnt = this.form.endtCnt === '' ? 0 : this.form.endtCnt
      this.showRiCoHelpList = true
    }
  },
  created() {
    this.doInit()
  },
  components: {
    PolicyHelpList,
    RiCoHelpList
  },
  mixins: [MessageMixin]
}
</script>
